angular.module('impactx.panel').directive('ixManufacturerPanel', function () {
    return {
        restrict: 'EA',
        controller: 'ManufacturerPanelCtrl',
        controllerAs: 'manufacturerPanelCtrl',
        scope: true,
        bindToController: {
            manufacturer: "=",
            currentFilter: "="
        },
        templateUrl: 'shared/panel/templates/manufacturer.panel.tmpl.html'
    }
});